import React, { useEffect, useState, useContext } from "react"
import { Row, Col, Card, CardBody, Button, Label } from "reactstrap"
import { post, put } from "helpers/api_helper"
import { useFormik } from "formik"
import * as Yup from "yup"
import { textField, selectField } from "components/Common/Form/InputFields"
import { CustomAlertContext } from "utils/context/CustomAlertContext"
import { yupMessages } from "helpers/validations/messages"
import { formats } from "helpers/validations/regex"

const WorkingHourForm = props => {
  const { disabled, working_hour_id, c_data } = props
  const customAlert = useContext(CustomAlertContext)
  const handleSubmit = values => {
    let callApi
    if (working_hour_id) {
      callApi = updateWorkingHour(values)
    } else {
      callApi = addWorkingHour(values)
    }

    callApi
      .then(res => {
        customAlert.notify(res.message)
        window.location.href = "/working-hours"
      })
      .catch(err => {
        console.log(`err.response`, err.response)

        customAlert.notify(err.response.data.message)
      })
  }

  const addWorkingHour = data => post(`working-hours`, data)

  const updateWorkingHour = data =>
    put(`working-hours/${working_hour_id}`, data)

  const WorkingHourSchema = Yup.object().shape({
    day: Yup.string()
      .trim(`Day ${yupMessages.trim}`)
      .required(`Day ${yupMessages.is_required}`)
      .matches(formats.string, yupMessages.name),
    start_time: Yup.string()
      .when("is_closed", {
        is: false,
        then: Yup.string()
          .required(`Start time ${yupMessages.is_required}`)
          .nullable(),
      })
      .nullable(),
    end_time: Yup.string()
      .test(
        "end_time",
        "end time should be greater than start time",
        (a, b) => {
          const { start_time, is_closed } = b.parent
          return !is_closed && a ? getDifferenceTime(start_time, a) : true
        }
      )
      .when("is_closed", {
        is: false,
        then: Yup.string()
          .required(`End time ${yupMessages.is_required}`)
          .nullable(),
      })
      .nullable(),

    is_closed: Yup.boolean(),
  })

  const getDifferenceTime = (start_time, end_time) => {
    var stt = new Date("May 26, 2016 " + start_time)
    stt = stt.getTime()

    var endt = new Date("May 26, 2016 " + end_time)
    endt = endt.getTime()

    if (stt >= endt) {
      return false
    } else {
      return true
    }
  }
  const formik = useFormik({
    initialValues: {
      day: c_data ? c_data.day : "monday",
      start_time: c_data ? c_data.start_time : "10:00",
      end_time: c_data ? c_data.end_time : "18:00",
      is_closed: c_data ? c_data.is_closed : false,
    },
    validationSchema: WorkingHourSchema,
    onSubmit: values => {
      handleSubmit(values)
    },
  })

  const handleClose = ev => {
    if (ev.target.checked) {
      formik.setFieldValue("start_time", "")
      formik.setFieldValue("end_time", "")
    }
    formik.setFieldValue("is_closed", ev.target.checked)
  }

  return (
    <Row>
      <Col className="col-12">
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <div className="mb-3">
                <Row>
                  <Col lg={12}>
                    {textField(
                      formik,
                      "day",
                      "Day*",
                      "enter day name",
                      false,
                      "text"
                    )}
                  </Col>
                  <Col lg={6}>
                    {textField(
                      formik,
                      "start_time",
                      "Start Time",
                      "select pickup start time",
                      false,
                      "time",
                      false,
                      formik.values.is_closed
                    )}
                  </Col>
                  <Col lg={6}>
                    {textField(
                      formik,
                      "end_time",
                      "End Time",
                      "select pickup end time",
                      false,
                      "time",
                      false,
                      formik.values.is_closed
                    )}
                  </Col>

                  <Col>
                    <input
                      type="checkbox"
                      name="is_closed"
                      onChange={handleClose}
                      checked={formik.values.is_closed}
                    />{" "}
                    closed
                  </Col>
                </Row>
              </div>

              {disabled ? null : (
                <div className="d-flex flex-wrap gap-2">
                  <Button type="submit" color="primary" className="">
                    Submit
                  </Button>{" "}
                </div>
              )}
            </form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default WorkingHourForm
